import axios from "configs/axios";
import {
  UPDATE_PASSWORD,
  UPDATE_PASSWORD_FAILURE,
  UPDATE_PROFILE,
  UPDATE_PROFILE_FAILURE,
} from "store/types";
import { handleSwal } from "utils/sweetAlert";

// UPDATE PROFILE
export const updateProfile = (url, data) => {
  return async (dispatch) => {
    dispatch({
      type: UPDATE_PROFILE,
      payload: {
        loading: true,
        data: false,
        errorMessage: false,
      },
      user: false,
    });

    try {
      var formdata = new FormData();
      if (data.image) {
        formdata.append("image", data.image);
      }
      formdata.append("name", data.name);
      formdata.append("province", data.province);
      formdata.append("city", data.city);
      formdata.append("address", data.address);
      formdata.append("phone", data.phone);
      // post to update profile body form data
      const updateResponse = await axios.put(
        `${process.env.REACT_APP_HOST}/api/v1${url}`,
        formdata,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      // Dispatch update profile success action
      dispatch({
        type: UPDATE_PROFILE,
        payload: {
          loading: false,
          data: updateResponse.data.accessToken,
          errorMessage: false,
        },
        user: updateResponse.data.data,
      });
      handleSwal("Update Profile Successful!", "success");
    } catch (error) {
      // Dispatch update profile failure action
      dispatch({
        type: UPDATE_PROFILE_FAILURE,
        payload: {
          loading: false,
          data: false,
          errorMessage: error.response.data,
        },
      });
      handleSwal(error.response.data.message, "error");
    }
  };
};

// UPDATE PASSWORD
export const updatePassword = (data) => {
  return async (dispatch) => {
    dispatch({
      type: UPDATE_PASSWORD,
      payload: {
        loading: true,
        data: false,
      },
    });

    try {
      // post to update password
      const updateResponse = await axios.put(`/change-password`, data, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
      });

      // Dispatch update password success action
      dispatch({
        type: UPDATE_PASSWORD,
        payload: {
          loading: false,
          data: updateResponse.data,
        },
      });
      handleSwal("Update Password Successful!", "success").then(() => {
        window.location.href = "/profile";
      });
    } catch (error) {
      // Dispatch update password failure action
      dispatch({
        type: UPDATE_PASSWORD_FAILURE,
        payload: {
          loading: false,
          errorMessage: error.response.data,
        },
      });
      handleSwal(error.response.data.message, "error");
    }
  };
};
